import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import RelationshipButton from 'Components/ComponentLibrary/Components/Uncategorized/RelationshipButton';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Typography from 'Components/UI/Typography';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const useStyles = buildUseStyles('ManagedAccountPageInfoBar', (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  balanceContainer: {
    marginRight: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  balance: {
    color: theme.palette.facet.naturalGreen,
    marginBottom: 0,
  },
  balanceExtraInfo: {
    marginBottom: 0,
  },
  stats: {
    display: 'flex',
    gap: theme.spacing(2),
    overflow: 'hidden',
  },
  ctaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  cta: {
    padding: theme.spacing(0.5, 2),
    fontSize: theme.typography.fontSize1Rem,
    fontWeight: theme.typography.fontWeightMedium,
    marginLeft: theme.spacing(1),
  },
  ctaText: {
    whiteSpace: 'noWrap',
    lineHeight: 1.75,
  },
}));

export default function ManagedAccountPageInfoBarLayout() {
  const classes = useStyles();
  const { resource } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();
  const { logTopBarEvent } = useManagedAccountPageEventLogger();
  const { loadModalCollectionByLink } = useModalContext();


  const isMobile = useMobileLayout();

  function handleTransferFundsClick() {
    logTopBarEvent('Transfer Funds');
    loadPageContentLink(resource.relationship(fr.relationships.accountTransferSetup.name).link('related'));
  }

  return (
    <Box className={classes.root} test="managed-account-page-info-bar">
      <Box className={classes.balanceContainer}>
        <MetaControlField onClick={() => logTopBarEvent('balance')} className={classes.balance} attr={'balance'} />
        {!isMobile ? <MetaControlField className={classes.balanceExtraInfo} attr={'lastUpdated'} /> : null}
      </Box>
      {!isMobile ? (
        <Box className={classes.stats}>
          <MetaControlField attr={'accountOwner'} simpleRootStyle />
          <MetaControlField attr={'accountNumber'} simpleRootStyle />
          <MetaControlField attr={'currentYearContributionTotal'} simpleRootStyle />
          <MetaControlField attr={'previousYearContributionTotal'} simpleRootStyle />
          <MetaControlField attr={'apy'} simpleRootStyle />
        </Box>)
        : null
      }
      <Box className={classes.ctaContainer}>
        <RelationshipButton
          className={classes.cta}
          resource={resource}
          relationship={fr.relationships.fundingInstructionsWizard.name}
          onClick={() => loadPageContentLink(resource.relationship(fr.relationships.fundingInstructionsWizard.name).link('related'))}
          test="managed-account-funding-instructions-button"
        >
          <Typography variant="h5" className={classes.ctaText}>Funding Instructions</Typography>
        </RelationshipButton>
        <RelationshipButton
          className={classes.cta}
          resource={resource}
          relationship={fr.relationships.accountTransferSetup.name}
          onClick={handleTransferFundsClick}
        >
          <Typography variant="h5" className={classes.ctaText}>Transfer Funds</Typography>
        </RelationshipButton>
        <RelationshipButton
          className={classes.cta}
          resource={resource}
          relationship={fr.relationships.updateModel.name}
          onClick={() => loadModalCollectionByLink(resource.relationship(fr.relationships.updateModel.name).link('related').url())}
        >
          <Typography variant="h5" className={classes.ctaText}>Update Model</Typography>
        </RelationshipButton>
      </Box>
    </Box>
  );
}
